import Column from '@components/column'
import Bio from '@commons/profile/bio'
import Specializations from '@commons/profile/specializations'
import Educations from './educations'
import Experiences from './experiences'
const Overview = () => {
  return (
    <Column rowGap={20}>
      <Bio />
      <Specializations />
      <Educations />
      <Experiences />
    </Column>
  )
}

export default Overview
